import React from "react";
import { toFlagAssetCode } from "../../utils/countryFlag";

// =====================================================================
// Image flag for the V2 agent-request surfaces (design doc 01 / brief
// RULE 2 flags exception).
//
// The V2 emoji flags rendered as letter pairs on Windows and are removed.
// This reuses the platform's EXISTING image-flag asset sources (the pattern
// club/agent search surfaces use, e.g. SearchTable): the API's
// country.image_url when present, else the flagcdn SVG for the resolved
// flag-asset code (toFlagAssetCode — handles the non-ISO home-nation codes the
// API emits, e.g. "en"). No new flag system — only the artboard's styling:
// 18x13 (card) / 20x14 (loupe) / 16x11.5 (list row), radius 2.5 (2 on the
// list), 1px ring, background-size cover.
//
// Renders NOTHING when the country can't be resolved — never a broken glyph.
// =====================================================================

// Platform flag-asset URL for a country name/code/object, or null.
export const flagImageUrl = (country) => {
  if (country && typeof country === "object" && country.image_url) {
    return country.image_url;
  }
  const code = toFlagAssetCode(country);
  return code ? `https://flagcdn.com/${code}.svg` : null;
};

// The artboard flag element: a cover-background span with a 1px ring.
// Size + radius come from `className` per surface (see header note).
const FlagImg = ({ country, className = "" }) => {
  const url = flagImageUrl(country);
  if (!url) return null;
  return (
    <span
      className={`flex-none bg-cover shadow-[0_0_0_1px_rgba(15,23,42,0.10)] ${className}`}
      style={{ backgroundImage: `url(${url})` }}
      aria-hidden="true"
      data-testid="country-flag"
    />
  );
};

export default FlagImg;
